/* ==========================================================
   Wolkenreich Matratzenfinder — Logic Engine v2
   Vanilla JS · Auto-advance · Shopify-Section-ready
   ========================================================== */

(function () {
  "use strict";

  const CONFIG = {
    // Neuer Single-Endpoint: ein POST geht an die Edge-Function,
    // die Supabase + GHL parallel erledigt. Secrets bleiben im Backend.
    submitEndpoint: window.WR_FINDER_SUBMIT_ENDPOINT || "https://kdxojwmcfibqpguohffh.supabase.co/functions/v1/finder-submit",
    shopUrl: window.WR_FINDER_SHOP_URL || "https://wolkenreich.at/products/orthopaedische-luftkernmatratze-schlafwolke7",
    consultUrl: window.WR_FINDER_CONSULT_URL || "https://api.leadconnectorhq.com/widget/booking/Csgv4J5y7TXXO6swhTiW",
    reviewsUrl: window.WR_FINDER_REVIEWS_URL || "reviews.json"
  };

  const STEP_ORDER = [
    "intro", "for_whom", "width", "position", "weight",
    "region", "diagnosis", "feel", "climate", "result"
  ];

  const TOTAL_QUESTIONS = 8;

  // ---------- Produkt-Katalog (aus Wolkenreich-Shop, Stand 23.04.2026) ----------
  const MATTRESS_CATALOG = {
    luftkern: {
      id: "luftkern",
      name: "schlafWOLKE 7",
      tagline: "Die Matratze, die zu dir passt.",
      url: "https://wolkenreich.at/products/orthopaedische-luftkernmatratze-schlafwolke7",
      image: "https://cdn.shopify.com/s/files/1/0935/3809/1395/files/schlafWOLKE_7_Pain_Einzeln_-_Cert_2117de67-ea01-4f7d-8265-3bab7394d253.jpg",
      priceFrom: 1592,
      specs: [
        { num: "60", label: "Stufen" },
        { num: "25", label: "Luftkammern" },
        { num: "30", label: "Nächte" },
        { num: "5", label: "Jahre Garantie" }
      ],
      reasoningTitle: "Warum die schlafWOLKE 7 zu dir passt"
    },
    vario: {
      id: "vario",
      name: "Vario Deluxe",
      tagline: "7-Zonen Kaltschaum mit austauschbaren Topper-Schichten.",
      url: "https://wolkenreich.at/products/7-zonen-kaltschaummatratze-wolkenreich-vario-deluxe-uno",
      image: "https://cdn.shopify.com/s/files/1/0935/3809/1395/files/kaltschaum-einzel-1-1.jpg",
      priceFrom: 759,
      specs: [
        { num: "7", label: "Zonen" },
        { num: "3", label: "Topper-Schichten" },
        { num: "30", label: "Nächte" }
      ],
      reasoningTitle: "Warum die Vario Deluxe zu dir passt"
    },
    dream: {
      id: "dream",
      name: "Dream Premium",
      tagline: "Taschenfederkern mit Bezug bei 60° waschbar.",
      url: "https://wolkenreich.at/products/taschenfederkernmatratze-premium-dream",
      image: "https://cdn.shopify.com/s/files/1/0935/3809/1395/files/Taschenfederkernmatratze-Premium-Dream-Main-Image-1_57981b54-a8a6-4d1b-95e9-4f4705530192.jpg",
      priceFrom: 699,
      specs: [
        { num: "1000+", label: "Tonnen-Federn" },
        { num: "60°", label: "Waschbar" },
        { num: "7", label: "Zonen" },
        { num: "30", label: "Nächte" }
      ],
      reasoningTitle: "Warum die Dream Premium zu dir passt"
    },
    maxiflex: {
      id: "maxiflex",
      name: "Maxi Flex Wende",
      tagline: "Taschenfederkern mit 2 Härtegraden — einfach wenden.",
      url: "https://wolkenreich.at/products/taschenfederkernmatratze-maxi-flex-w",
      image: "https://cdn.shopify.com/s/files/1/0935/3809/1395/files/Maxi-Flex-Main-Image_38012f08-bdf2-46e3-a399-30ee0b2c5ae3.jpg",
      priceFrom: 609,
      specs: [
        { num: "2", label: "Härtegrade" },
        { num: "500+", label: "Federn" },
        { num: "7", label: "Zonen" },
        { num: "30", label: "Nächte" }
      ],
      reasoningTitle: "Warum die Maxi Flex Wende zu dir passt"
    },
    gelziptop: {
      id: "gelziptop",
      name: "Luxus Gel Zip-Top",
      tagline: "Reversibler Gel-Topper — Sommer kühl, Winter warm.",
      url: "https://wolkenreich.at/products/luxus-taschenfederkern-matratze-gel-zip-top",
      image: "https://cdn.shopify.com/s/files/1/0935/3809/1395/files/Luxus-Taschenfederkern-Gel-Zip-Top-Main-Image_91fe357c-c7a0-43e5-8c3d-f7a084ecff2e.jpg",
      priceFrom: 1279,
      specs: [
        { num: "31", label: "cm Höhe" },
        { num: "1000+", label: "Federn" },
        { num: "2", label: "Seiten" },
        { num: "30", label: "Nächte" }
      ],
      reasoningTitle: "Warum die Gel Zip-Top zu dir passt"
    }
  };

  // ---------- Empfehlungs-Engine (Luftkern-maximal, ohne Budget-Filter) ----------
  function recommend(a) {
    // Luftkern gewinnt fast immer — nur bestimmte Profile führen auf andere Matratzen
    // (for_whom=kind, schwitze+keine Diagnose, wechselnd+keine Diagnose)

    if (a.for_whom === "kind") return { mattress: MATTRESS_CATALOG.dream, showFinance: false };

    const keineDiagnose = a.diagnosis === "nur_verspannungen" || !a.diagnosis;

    if (a.climate === "schwitze" && keineDiagnose && a.for_whom !== "partner" && a.feel === "gestuetzt") {
      return { mattress: MATTRESS_CATALOG.gelziptop, showFinance: false };
    }
    if (a.position === "wechselnd" && keineDiagnose && a.for_whom !== "partner" && a.feel === "gestuetzt") {
      return { mattress: MATTRESS_CATALOG.maxiflex, showFinance: false };
    }

    // Default: schlafWOLKE 7 für alle anderen Fälle
    return { mattress: MATTRESS_CATALOG.luftkern, showFinance: false };
  }

  const ADVANCE_DELAY = {
    default: 420,
    diagnosis: 3200   // Review-Card auf Q5b war früher hier; jetzt nur noch falls wieder reaktiviert
  };

  const STATE = {
    currentStepIndex: 0,
    answers: {},
    reviews: [],
    advanceTimer: null,
    sessionId: null,
    utm: {},
    sessionPromise: null   // in-flight Promise (verhindert Duplicate-Inserts)
  };

  // ---------- Answer-Allowlists (Security: XSS-Schutz vor innerHTML-Render) ----------
  const ALLOWED_ANSWERS = {
    for_whom:   ["mich", "partner", "kind"],
    width:      ["90_120", "140", "160_200"],
    position:   ["seite", "ruecken", "bauch", "wechselnd"],
    weight:     ["u60", "60_80", "80_100", "100_120", "ab120"],
    region:     ["lendenbereich", "schulter_nacken", "hueft", "ueberall", "keine_beschwerden"],
    diagnosis:  ["bandscheibe", "skoliose", "isg", "fibromyalgie", "nur_verspannungen"],
    feel:       ["wolke", "gestuetzt", "anpassbar"],
    climate:    ["friere", "normal", "schwitze"]
  };

  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function safeAnswer(field, value) {
    const allowed = ALLOWED_ANSWERS[field];
    return (allowed && allowed.includes(value)) ? value : null;
  }

  function sanitizedAnswers() {
    const clean = {};
    for (const f of Object.keys(ALLOWED_ANSWERS)) {
      const v = safeAnswer(f, STATE.answers[f]);
      if (v) clean[f] = v;
    }
    return clean;
  }

  function stripQuery(u) {
    if (!u) return null;
    try {
      const x = new URL(u);
      x.search = "";
      x.hash = "";
      return x.toString();
    } catch {
      return null;
    }
  }

  // ---------- Session-ID + UTM-Capture ----------
  function uuid() {
    if (crypto.randomUUID) return crypto.randomUUID();
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
      const r = Math.random() * 16 | 0;
      return (c === "x" ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  function getOrCreateSessionId() {
    try {
      const existing = sessionStorage.getItem("wr_finder_session_id");
      if (existing) return existing;
      const id = uuid();
      sessionStorage.setItem("wr_finder_session_id", id);
      return id;
    } catch {
      return uuid();
    }
  }

  function captureUtm() {
    const p = new URLSearchParams(window.location.search);
    const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
    const utm = {};
    keys.forEach(k => {
      const v = p.get(k);
      if (v) utm[k] = v;
    });
    return utm;
  }

  // ---------- Review Loader ----------
  async function loadReviews() {
    try {
      const res = await fetch(CONFIG.reviewsUrl, { cache: "default" });
      if (!res.ok) throw new Error("reviews fetch failed");
      const data = await res.json();
      STATE.reviews = data.reviews || [];
    } catch (err) {
      STATE.reviews = FALLBACK_REVIEWS;
    }
  }

  function findReviewForDiagnosis(diagnosis) {
    if (!diagnosis) return null;
    const matches = STATE.reviews.filter(r =>
      Array.isArray(r.categories) && r.categories.includes(diagnosis)
    );
    if (matches.length === 0) return STATE.reviews[0] || null;
    return matches[Math.floor(Math.random() * matches.length)];
  }

  // ---------- Stepper ----------
  function getStepEl(name) {
    return document.querySelector(`.wr-step[data-step="${name}"]`);
  }

  function showStep(index) {
    clearAdvanceTimer();

    const name = STEP_ORDER[index];
    const el = getStepEl(name);
    const prev = document.querySelector(".wr-step.active");

    const activate = () => {
      document.querySelectorAll(".wr-step").forEach(s => {
        s.classList.remove("active", "is-leaving");
      });
      if (el) el.classList.add("active");
      STATE.currentStepIndex = index;

      const finder = document.getElementById("finder");
      if (finder) {
        finder.classList.toggle("is-intro", name === "intro");
        finder.classList.toggle("is-quiz", name !== "intro");
      }

      updateProgress();
      updateHeader(name, el);
      window.scrollTo({ top: 0, behavior: "smooth" });

      if (name === "result") {
        renderResult();
        loadVideoLazy();
      }
    };

    if (prev && prev !== el) {
      prev.classList.add("is-leaving");
      setTimeout(activate, 320);
    } else {
      activate();
    }
  }

  function updateProgress() {
    const name = STEP_ORDER[STATE.currentStepIndex];
    let pct = 0;
    if (name === "intro") pct = 0;
    else if (name === "result") pct = 100;
    else {
      // Questions 1..7 = for_whom..climate → index 1..8 in STEP_ORDER
      const qIdx = STATE.currentStepIndex;
      pct = (qIdx / (STEP_ORDER.length - 1)) * 100;
    }
    const bar = document.getElementById("progressBar");
    if (bar) bar.style.width = pct + "%";
  }

  function updateHeader(name, stepEl) {
    const backNav = document.getElementById("backNav");
    const counter = document.getElementById("stepCounter");
    const isQuestion = name !== "intro" && name !== "result";
    const isResult = name === "result";

    // Back-Button: in Fragen + Ergebnis sichtbar
    if (backNav) backNav.hidden = name === "intro";

    // Step-Counter nur bei Fragen
    if (counter) counter.hidden = !isQuestion;

    if (isQuestion && stepEl) {
      const num = stepEl.dataset.stepNum || "";
      const now = document.getElementById("stepNow");
      const total = document.getElementById("stepTotal");
      if (now) now.textContent = num;
      if (total) total.textContent = TOTAL_QUESTIONS;
    }
  }

  function goNext() {
    if (STATE.currentStepIndex < STEP_ORDER.length - 1) {
      showStep(STATE.currentStepIndex + 1);
    }
  }

  function goBack() {
    if (STATE.currentStepIndex > 0) {
      showStep(STATE.currentStepIndex - 1);
    }
  }

  function clearAdvanceTimer() {
    if (STATE.advanceTimer) {
      clearTimeout(STATE.advanceTimer);
      STATE.advanceTimer = null;
    }
  }

  function scheduleAdvance(field) {
    clearAdvanceTimer();
    const delay = ADVANCE_DELAY[field] || ADVANCE_DELAY.default;
    STATE.advanceTimer = setTimeout(() => {
      goNext();
    }, delay);
  }

  // ---------- Binding ----------
  function bindChoiceInputs() {
    document.querySelectorAll(".wr-choices").forEach(group => {
      const field = group.dataset.field;
      const step = group.closest(".wr-step");
      const skipBtn = step && step.querySelector(".wr-skip-btn");

      group.querySelectorAll("input[type=radio]").forEach(input => {
        input.addEventListener("change", () => {
          STATE.answers[field] = input.value;
          toggleConditionalInfo(field, input.value);

          if (skipBtn) skipBtn.disabled = false;
          scheduleAdvance(field);
        });
      });
    });
  }

  function toggleConditionalInfo(field, value) {
    document.querySelectorAll(`[data-show-when-field="${field}"]`).forEach(el => {
      el.style.display = el.dataset.showWhenValue === value ? "flex" : "none";
    });
  }

  function bindNav() {
    document.querySelectorAll("[data-next]").forEach(btn => {
      btn.addEventListener("click", () => {
        clearAdvanceTimer();
        goNext();
      });
    });
    const backNav = document.getElementById("backNav");
    if (backNav) backNav.addEventListener("click", goBack);

    // Keyboard: Escape = zurück
    document.addEventListener("keydown", e => {
      if ((e.key === "Escape") && STATE.currentStepIndex > 0 && STATE.currentStepIndex < STEP_ORDER.length - 1) {
        goBack();
      }
    });
  }

  // ---------- Expand-Text Toggle ----------
  function bindExpandText() {
    const btn = document.getElementById("expandText");
    const wrap = document.getElementById("resultTextWrap");
    if (!btn || !wrap) return;
    btn.addEventListener("click", () => {
      wrap.classList.toggle("is-collapsed");
    });
  }

  // ---------- Review auf Ergebnisseite (passend zur Diagnose oder Region) ----------
  function renderResultReview(answers) {
    const card = document.getElementById("resultReview");
    if (!card) return;
    const key = answers.diagnosis || answers.region;
    const review = findReviewForDiagnosis(key);
    if (!review) { card.hidden = true; return; }
    document.getElementById("reviewText").textContent = review.text;
    document.getElementById("reviewAuthor").textContent = `— ${review.name}, Trusted Shops`;
    card.hidden = false;
  }

  // ---------- Result Engine ----------
  function renderResult() {
    // XSS-Hardening: nur whitelisted Antworten in den innerHTML-Render geben
    const clean = sanitizedAnswers();
    const { mattress, showFinance } = recommend(clean);

    // Produkt-Info (Title, Tagline, Image, CTA)
    const imgEl    = document.querySelector("#resultHero img");
    const titleEl  = document.getElementById("resultTitle");
    const lineEl   = document.getElementById("resultTagline");
    const ctaEl    = document.getElementById("ctaToShop");
    const reasonTitleEl = document.getElementById("resultReasoningTitle");

    if (imgEl) { imgEl.src = mattress.image; imgEl.alt = mattress.name; }
    if (titleEl) titleEl.textContent = mattress.name;
    if (lineEl) lineEl.textContent = mattress.tagline;
    if (ctaEl) {
      ctaEl.href = mattress.url;
      const label = ctaEl.querySelector(".wr-cta-label");
      if (label) label.textContent = `${mattress.name} ansehen`;
    }
    if (reasonTitleEl) {
      const labelSpan = reasonTitleEl.querySelector(".wr-reason-label");
      if (labelSpan) labelSpan.textContent = mattress.reasoningTitle;
    }

    // Specs pro Matratze
    const specsEl = document.getElementById("resultSpecs");
    if (specsEl) {
      specsEl.innerHTML = mattress.specs.map(s =>
        `<div class="wr-spec"><span class="wr-spec-num">${s.num}</span><span class="wr-spec-label">${s.label}</span></div>`
      ).join("");
    }

    // Garantie gilt nur für Luftkernmatratzen (Entscheidung 05.10.2026): Hinweis in der Vertrauenszeile nur bei der schlafWOLKE 7
    const garantieEl = document.getElementById("trustGarantie");
    if (garantieEl) {
      const ohneGarantie = mattress.id !== "luftkern";
      garantieEl.hidden = ohneGarantie;
      if (garantieEl.parentElement) garantieEl.parentElement.classList.toggle("wr-trust-row--ohne-garantie", ohneGarantie);
    }

    // Reasoning-Text dynamisch pro Matratze
    const container = document.getElementById("resultText");
    if (container) container.innerHTML = buildResultText(mattress.id, clean);

    // Finanzierungs-Banner
    const finEl = document.getElementById("financeBanner");
    if (finEl) finEl.hidden = !showFinance;

    const wrap = document.getElementById("resultTextWrap");
    if (wrap) wrap.classList.add("is-collapsed");
    renderResultReview(clean);
    persistResult();
    insertSessionOnce();
  }

  // ---------- Dynamischer Result-Text pro Matratze ----------
  function buildResultText(mattressId, a) {
    if (mattressId === "luftkern") {
      return buildDeepResultText(a);
    }
    const simpleTexts = {
      vario: [
        "Deine Antworten zeigen einen klaren Schlaf-Standard ohne Diagnose und ein gezieltes Budget. Dafür ist die <strong>Vario Deluxe</strong> die ehrlichste Empfehlung: 7-Zonen Kaltschaum mit Topper-Schichten, die du bei Bedarf austauschen kannst.",
        "Ehrlich gesagt: Eine Luftkern-Matratze wäre hier overkill. Die Vario Deluxe gibt dir stabilen Liegekomfort und Atmungsaktivität durch den Kaltschaum-Kern, zu einem Preis, der zu deinem Budget passt.",
        "Wenn sich dein Bedarf später ändert (andere Zonen, andere Festigkeit), tauschst du die Topper-Schicht. Das hält die Matratze über Jahre an dein Leben angepasst."
      ],
      dream: [
        "Für dein Kind ist die <strong>Dream Premium</strong> die richtige Wahl: Taschenfederkern mit einem Bezug, der bei 60° waschbar ist — Hygiene, die bei Kindern den entscheidenden Unterschied macht.",
        "Über 1.000 Tonnen-Taschenfedern geben stabile Unterstützung für einen wachsenden Körper, ohne dass die Matratze überkonstruiert ist. Ein Federkern, der ehrlich das kann, was ein Kind braucht.",
        "30 Nächte Probeschlafen inklusive — damit ihr beide sicher seid, dass die Matratze passt, bevor sie bleibt."
      ],
      maxiflex: [
        "Weil du deine Schlafposition häufig wechselst und beim Budget auf den Punkt gehst, passt die <strong>Maxi Flex Wende</strong>: Taschenfederkern mit zwei unterschiedlichen Härtegraden — eine Seite fest, eine weicher.",
        "Einfach wenden, und du hast quasi zwei Matratzen in einer. Wenn sich dein Schlaf verändert oder du merkst, die andere Seite passt besser, kein Neukauf nötig.",
        "Der 7-Zonen-Aufbau sorgt dafür, dass Schulter und Hüfte entsprechend einsinken — ehrlich gute Qualität zum Einstiegspreis."
      ],
      gelziptop: [
        "Weil du nachts zu den Warm-Schläfern gehörst und dein Budget im mittleren Bereich liegt, ist die <strong>Luxus Gel Zip-Top</strong> die richtige Wahl: Taschenfederkern mit einem reversiblen Gel-Topper.",
        "Eine Seite kühlt aktiv — ideal für warme Nächte. Umdrehen im Winter, und die wärmere Seite liegt oben. Du hast praktisch zwei saisonale Matratzen in einer.",
        "1.000+ Tonnen-Federn für stabile Unterstützung, 31 cm Bauhöhe für echtes Hotel-Feeling."
      ]
    };
    const paragraphs = simpleTexts[mattressId] || simpleTexts.vario;
    return paragraphs.map(p => `<p>${p}</p>`).join("");
  }

  // ---------- Submit-Endpoint (Supabase Edge Function) ----------
  async function submitToEndpoint(action, extra = {}) {
    if (!CONFIG.submitEndpoint) {
      console.log("[Wolkenreich Finder] submitEndpoint not configured, skipping", action);
      return null;
    }
    const clean = sanitizedAnswers();
    const payload = {
      action,
      session_id: STATE.sessionId,
      answers: clean,
      tags: buildLeadTags(clean),
      url: stripQuery(window.location.href),
      referrer: stripQuery(document.referrer) || null,
      user_agent: (navigator.userAgent || "").slice(0, 500),
      language: (navigator.language || "").slice(0, 20),
      utm: STATE.utm,
      ...extra
    };
    try {
      const res = await fetch(CONFIG.submitEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      const result = await res.json().catch(() => null);
      if (!res.ok) {
        console.warn("[Wolkenreich Finder]", action, "failed:", res.status, result);
        return { ok: false, status: res.status, body: result };
      }
      return { ok: true, status: res.status, body: result };
    } catch (err) {
      console.error("[Wolkenreich Finder]", action, "network error:", err);
      return { ok: false, status: 0, body: null };
    }
  }

  // In-flight Promise-Tracking (verhindert Duplicate-Inserts bei Back/Forward-Races)
  function insertSessionOnce() {
    if (STATE.sessionPromise) return STATE.sessionPromise;
    STATE.sessionPromise = submitToEndpoint("session").then(r => {
      // Bei echter Fehl-Response Promise zurücksetzen damit Retry möglich ist
      if (r && !r.ok && r.status !== 200) {
        STATE.sessionPromise = null;
      }
      return r;
    }).catch(err => {
      STATE.sessionPromise = null;
      throw err;
    });
    return STATE.sessionPromise;
  }

  async function insertLead(email, phone, wantsCall, consent) {
    // Empfohlene Matratze mitsenden — Edge Function setzt daraus GHL Custom Fields
    const clean = sanitizedAnswers();
    const { mattress } = recommend(clean);
    return submitToEndpoint("lead", {
      email,
      phone: phone || null,
      wants_call: Boolean(wantsCall),
      consent: consent === true,
      recommended: mattress ? mattress.id : null
    });
  }

  function buildDeepResultText(a) {
    const opener = buildOpener(a);
    const reasoning = buildReasoning(a);
    const feelParagraph = buildFeelParagraph(a);
    const climate = buildClimateLine(a);
    const closing = buildClosing(a);

    return [opener, reasoning, feelParagraph, climate, closing]
      .filter(Boolean)
      .map(p => `<p>${p}</p>`)
      .join("");
  }

  function buildOpener(a) {
    const diagnosisText = {
      bandscheibe: "Da du bereits einen <em>Bandscheibenvorfall</em> hattest oder aktuell darunter leidest,",
      skoliose: "Da du eine <em>Skoliose</em> angegeben hast,",
      isg: "Da du <em>ISG-Blockaden und Gelenkschmerzen</em> angegeben hast,",
      fibromyalgie: "Da du <em>Fibromyalgie</em> und erhöhte Druckempfindlichkeit angegeben hast,",
      nur_verspannungen: "Du hast keine Diagnose, aber <em>Verspannungen</em> angegeben —",
    };
    const opener = diagnosisText[a.diagnosis] || "Basierend auf deinen Antworten";
    return `${opener} ist die <strong>schlafWOLKE 7</strong> für dich die richtige Wahl — unsere orthopädische Luftkernmatratze, die sich deinem Körper stufenlos anpasst.`;
  }

  function buildReasoning(a) {
    const positionText = {
      seite: "Als <em>Seitenschläfer</em> kommt es darauf an, dass Schulter und Hüfte tief genug einsinken, damit deine Wirbelsäule in einer geraden Linie bleibt.",
      ruecken: "Als <em>Rückenschläfer</em> brauchst du eine stabile Unterstützung der Lendenwirbelsäule, damit dein unterer Rücken nachts nicht durchhängt.",
      bauch: "Als <em>Bauchschläfer</em> brauchst du eine Matratze, die dich gleichmäßig stützt, ohne dass dein Becken zu tief einsinkt.",
      wechselnd: "Weil du die Position häufig wechselst, brauchst du eine Matratze, die sich bei jeder Lage mit dir bewegt — nicht eine, die nur in einer Position optimal ist."
    };
    const regionText = {
      lendenbereich: "Gerade im <em>unteren Rücken</em> kannst du den Luftdruck so einstellen, dass die Lendenwirbelsäule exakt die Stützung bekommt, die du brauchst.",
      schulter_nacken: "Für <em>Schulter und Nacken</em> lässt sich der obere Teil weicher einstellen — die Schulter sinkt ein, der Druck auf Halswirbelsäule und Schultergelenk verschwindet.",
      hueft: "Besonders für die <em>Hüfte</em> funktioniert die Luftkammertechnik hervorragend — punktgenaue Druckentlastung, ohne dass der Rest der Matratze weich wird.",
      ueberall: "Weil du <em>überall</em> Verspannungen spürst, wirst du den Unterschied schon in den ersten Nächten merken — die Matratze gleicht Druckspitzen an allen Körperregionen aus.",
      keine_beschwerden: "Auch ohne aktuelle Beschwerden lohnt sich die Investition in die Luftkerntechnik — du vermeidest langfristig die typischen Probleme klassischer Matratzen."
    };
    const diagnosisAddon = {
      bandscheibe: "Die individuelle Einstellbarkeit ist hier entscheidend: In akuten Phasen fährst du weicher, bei stabilem Zustand fester — alles per Fernbedienung.",
      skoliose: "Der Luftkern stabilisiert deine Wirbelsäule exakt in der Krümmung, die du als entlastend empfindest — ohne Gegendruck auf die ausgeprägte Seite.",
      isg: "Das ISG reagiert empfindlich auf Fehlstellungen. Mit 25 Luftkammern kannst du die Stützung gezielt dorthin legen, wo du sie brauchst.",
      fibromyalgie: "Bei erhöhter Druckempfindlichkeit ist eine punktelastische, anpassbare Oberfläche Gold wert — du reduzierst Druckspitzen, ohne komplett durchzusinken.",
      nur_verspannungen: "Viele Verspannungen entstehen nicht durch eine Diagnose, sondern durch eine Matratze, die nicht mehr passt. Das lässt sich hier stufenlos korrigieren."
    };
    return [positionText[a.position], regionText[a.region], diagnosisAddon[a.diagnosis]]
      .filter(Boolean).join(" ");
  }

  function buildFeelParagraph(a) {
    const feelText = {
      wolke: "Du möchtest <em>schwerelos wie auf einer Wolke</em> liegen — genau dafür ist der Luftkern gebaut. Mit einer weichen Einstellung (Stufe 10 bis 25 von 60) sinkst du sanft ein, ohne den Halt zu verlieren.",
      gestuetzt: "Du bevorzugst ein <em>fest gestütztes Liegegefühl</em> — kein Problem: Stell den Luftdruck höher (Stufe 40 bis 60) und behalte trotzdem die Anpassbarkeit der 25 einzelnen Luftkammern.",
      anpassbar: "Du bist dir noch <em>unsicher, wie du am liebsten liegst</em> — genau dafür ist die schlafWOLKE 7 gebaut. 60 Stufen per Fernbedienung. Heute weich, morgen fest, übermorgen dazwischen."
    };
    return feelText[a.feel] || "";
  }

  function buildClimateLine(a) {
    const climateText = {
      friere: "Weil du nachts <em>schnell frierst</em>, empfehlen wir dir zusätzlich unseren wärmeregulierenden Topper — er speichert Körperwärme und schafft sofort ein angenehmes Schlafklima.",
      schwitze: "Weil du nachts <em>eher schwitzt</em>, wird dich der atmungsaktive Aufbau der schlafWOLKE 7 überzeugen — Luftkammern transportieren Feuchtigkeit ab, und unser Klima-Topper verstärkt den Effekt.",
      normal: ""
    };
    return climateText[a.climate] || "";
  }

  function buildClosing(a) {
    const width = a.width === "160_200"
      ? "Weil dein Bett 160 cm oder breiter ist, verbauen wir <em>zwei separate Luftkerne</em> — du und dein Partner stellen eure Seiten unabhängig voneinander ein. Keine Besucherritze, keine Kompromisse."
      : a.for_whom === "partner"
      ? "Für euch als Paar passt sich der Luftkern beiden Körpern bestmöglich an. Bei späterem Wechsel auf 160 cm oder mehr bekommt ihr zwei separate Kerne pro Seite."
      : "";
    const tail = `<strong>Was jetzt auf dich wartet:</strong> 30 Nächte Probeschlafen bei dir zu Hause. Falls sie nicht passt, holen wir sie kostenlos ab.`;
    return [width, tail].filter(Boolean).join(" ");
  }

  // ---------- Video (Click-to-Play) ----------
  function loadVideoLazy() {
    // Poster-Button ist default; Iframe lädt erst beim ersten Klick
    const poster = document.getElementById("videoPoster");
    const iframe = document.getElementById("floVideo");
    if (!poster || !iframe) return;
    if (poster.dataset.bound === "1") return;
    poster.dataset.bound = "1";

    poster.addEventListener("click", () => {
      if (iframe.dataset.src) {
        iframe.src = iframe.dataset.src;
      }
      iframe.hidden = false;
      poster.hidden = true;
    });
  }

  // ---------- Beratungs-Link ----------
  function bindConsultLink() {
    const btn = document.getElementById("ctaBooking");
    if (!btn) return;
    btn.addEventListener("click", e => {
      e.preventDefault();
      window.open(CONFIG.consultUrl, "_blank", "noopener");
    });
  }

  // ---------- Lead Submit ----------
  function showLeadError(msg) {
    const form = document.getElementById("leadForm");
    if (!form) return;
    let errEl = form.querySelector(".wr-lead-error");
    if (!errEl) {
      errEl = document.createElement("div");
      errEl.className = "wr-lead-error";
      errEl.setAttribute("role", "alert");
      errEl.style.cssText = "margin-top:10px;padding:10px 14px;background:#FEF3F2;color:#B42318;border:1px solid #FDA29B;border-radius:8px;font-size:13.5px;line-height:1.4";
      form.appendChild(errEl);
    }
    errEl.textContent = msg;
    errEl.hidden = false;
  }

  function hideLeadError() {
    const el = document.querySelector(".wr-lead-error");
    if (el) el.hidden = true;
  }

  function bindLeadForm() {
    const form = document.getElementById("leadForm");
    if (!form) return;
    form.addEventListener("submit", async e => {
      e.preventDefault();
      hideLeadError();

      const consent = document.getElementById("leadConsent");
      if (!consent.checked) {
        showLeadError("Bitte bestätige kurz, dass wir dich kontaktieren dürfen.");
        consent.focus();
        return;
      }

      const email = document.getElementById("leadEmail").value.trim().toLowerCase();
      const phone = document.getElementById("leadPhone").value.trim();

      if (!EMAIL_RE.test(email) || email.length > 254) {
        showLeadError("Bitte gib eine gültige E-Mail-Adresse ein.");
        document.getElementById("leadEmail").focus();
        return;
      }

      const wantsCall = Boolean(phone);
      const submitBtn = form.querySelector("button[type=submit]");
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = "Wird gesendet…"; }

      const result = await insertLead(email, phone, wantsCall, consent.checked);

      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = "Ergebnis per Mail sichern"; }

      // Success nur zeigen wenn Backend wirklich bestätigt hat
      const ok = result && result.ok && result.body && (
        result.body.lead_inserted ||
        result.body.lead_already_existed ||
        result.body.ghl_contact_id
      );

      if (ok || !CONFIG.submitEndpoint) {
        form.hidden = true;
        document.getElementById("leadSuccess").hidden = false;
      } else {
        showLeadError("Irgendwas ist schiefgelaufen. Bitte probier es gleich nochmal — oder ruf uns an: +43 3452 21 011.");
      }
    });
  }

  // Nur segmentierungs-relevante Tags. Strukturdaten (for_whom, width, position,
  // weight, feel, climate) liegen in GHL-Custom-Fields.
  function buildLeadTags(a) {
    const tags = ["matratzenfinder", "finder-lead"];
    if (a.region && a.region !== "keine_beschwerden") tags.push(`region:${a.region}`);
    if (a.diagnosis && a.diagnosis !== "nur_verspannungen") tags.push(`diagnosis:${a.diagnosis}`);
    return tags;
  }

  function persistResult() {
    try { sessionStorage.setItem("wr_finder_answers", JSON.stringify(STATE.answers)); }
    catch (e) { /* ignore */ }
  }

  // ---------- Fallback Reviews ----------
  const FALLBACK_REVIEWS = [
    {
      name: "Wolkenreich Kunde",
      text: "Bei akuten Kreuzschmerzen kann die Matratze individuell nach Bedarf eingestellt werden, damit man leichter aufstehen kann.",
      categories: ["lendenbereich", "bandscheibe", "isg", "ueberall"]
    },
    {
      name: "Wolkenreich Kunde",
      text: "Ich kann jetzt endlich, trotz meiner Gelenksschmerzen, wieder durchschlafen.",
      categories: ["hueft", "schulter_nacken", "fibromyalgie"]
    },
    {
      name: "Wolkenreich Kunde",
      text: "Wir stehen morgens endlich wieder ohne Rückenschmerzen auf.",
      categories: ["lendenbereich", "nur_verspannungen", "skoliose"]
    }
  ];

  // ---------- Init ----------
  async function init() {
    STATE.sessionId = getOrCreateSessionId();
    STATE.utm = captureUtm();
    await loadReviews();
    bindChoiceInputs();
    bindNav();
    bindLeadForm();
    bindConsultLink();
    bindExpandText();
    showStep(0);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})();
